<div fxLayout="column">
    <p-table *ngIf="selectedDataType === 'top'" [@flyInOut] [value]="topNDataToShow" scrollable="true" scrollHeight="40vh" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->[pSortableColumn]="'day1Amount'"
        <!-- scrollHeight="40vh"> -->
        
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Top Contributions</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'Source'" style="width:35%">Source
                    <p-sortIcon [field]="'Source'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Origin'" style="width:35%">Origin
                    <p-sortIcon [field]="'Origin'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Amount'" >Amount
                    <p-sortIcon [field]="'Amount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:35%">{{row.Source}}</td>
                <td style="width:35%">{{row.Origin}}</td>
                <td *ngIf="isPositive(row.Amount)" class="positive-cell">
                    <span>{{row.Amount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.Amount)" class="negative-cell">
                    <span>{{row.Amount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>

        <!-- <p-header [class]="'liquitics-h5 explain-header ' + currencyClass()">Top Contributions</p-header>
        <p-column field="Source" header="Source" [style]="{'text-align':'right','width':'35%'}"></p-column>
        <p-column field="Origin" header="Origin" [style]="{'text-align':'right','width':'35%'}">
        </p-column>
        <p-column field="Amount" header="Amount">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.Amount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.Amount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.Amount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.Amount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'topByType'" [@flyInOut] [value]="topNDataByTypeToShow" scrollable="true" scrollHeight="40vh" class="liquitics-compact-table" styleClass="p-datatable-striped">
        <!-- scrollHeight="40vh"> -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Top Contributions</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'Source'"  style="width:35%">Source
                    <p-sortIcon [field]="'Source'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Origin'"  style="width:35%">Origin
                    <p-sortIcon [field]="'Origin'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'Amount'" >Amount
                    <p-sortIcon [field]="'Amount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:35%">{{row.Source}}</td>
                <td style="width:35%">{{row.Origin}}</td>
                <td *ngIf="isPositive(row.Amount)" class="positive-cell">
                    <span>{{row.Amount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.Amount)" class="negative-cell">
                    <span>{{row.Amount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>
        <!-- <p-header [class]="'liquitics-h5 explain-header ' + currencyClass()">Top Contributions</p-header>
        <p-column field="Source" header="Source" [style]="{'text-align':'right','width':'35%'}"></p-column>
        <p-column field="Origin" header="Origin" [style]="{'text-align':'right','width':'35%'}">
        </p-column>
        <p-column field="Amount" header="Amount">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.Amount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.Amount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.Amount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.Amount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Contractual'" [@flyInOut] [value]="contractualFlowTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" scrollHeight="35vh" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh"  > -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Contractual Flows</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'productType'" style="width:35%">Product Type
                    <p-sortIcon [field]="'productType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'desk'" style="width:35%">Desk
                    <p-sortIcon [field]="'desk'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'flowAmount'">Amount
                    <p-sortIcon [field]="'flowAmount'"></p-sortIcon>

                </th>
                <th style="width:7%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:35%">{{row.productType}}</td>
                <td style="width:35%">{{row.desk}}</td>
                <td *ngIf="isPositive(row.flowAmount)" class="positive-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.flowAmount)" class="negative-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
                <td style="width:7%">
                    <span class="transaction-detail fa fa-expand" (click)="showTransactionDetails(row)"></span>
                </td>
            </tr>
        </ng-template>
<!-- 
        <p-header [class]="'liquitics-h5 explain-header ' + currencyClass()">Contractual Flows</p-header>
        <p-column field="productType" header="Product Type" [sortable]="true" [style]="{'text-align':'right','width':'35%'}"></p-column>
        <p-column field="desk" header="Desk" [sortable]="true" [style]="{'text-align':'right','width':'35%'}">
        </p-column>
        <p-column field="flowAmount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.flowAmount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.flowAmount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.flowAmount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.flowAmount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
<!--Already commented-->
        <!-- <p-column field="todayAmount" header="Today" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.todayAmount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.todayAmount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.todayAmount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.todayAmount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
        <!-- <p-column [styleClass]="'col-expand'" field="" header="" [style]="{'width':'7%','text-align':'center'}">
            <ng-template let-entry="rowData" pTemplate="body">
                <span class="transaction-detail fa fa-expand" (click)="showTransactionDetails(entry)"></span>
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Unexpected'" [@flyInOut] [value]="unexpectedFlowTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh"> -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Unexpected Flows</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'desk'" style="width:30%">Desk
                    <p-sortIcon [field]="'desk'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'clientGroup'" style="width:30%">Client Group
                    <p-sortIcon [field]="'clientGroup'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'productType'" style="width:20%">Product Type
                    <p-sortIcon [field]="'productType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'flowAmount'">Amount
                    <p-sortIcon [field]="'flowAmount'"></p-sortIcon>
                </th>
                <th style="width:7%"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:30%">{{row.desk}}</td>
                <td style="width:30%">{{row.clientGroup}}</td>
                <td style="width:20%">{{row.productType}}</td>
                <td *ngIf="isPositive(row.flowAmount)" class="positive-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.flowAmount)" class="negative-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
                <td style="width:7%">
                    <span class="transaction-detail fa fa-expand" (click)="showTransactionDetails(row)"></span>
                </td>
            </tr>
        </ng-template>


        <!-- <p-header [class]="'liquitics-h5 explain-header ' + currencyClass()">Unexpected Flows</p-header>
        <p-column field="desk" header="Desk" [sortable]="true" [style]="{'text-align':'right','width':'30%'}"></p-column>
        <p-column field="clientGroup" header="Client Group" [sortable]="true" [style]="{'text-align':'right','width':'30%'}"></p-column>
        <p-column field="productType" header="Product Type" [sortable]="true" [style]="{'text-align':'right','width':'20%'}"></p-column>
        <p-column field="flowAmount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.flowAmount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.flowAmount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.flowAmount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.flowAmount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column>
        <p-column [styleClass]="'col-expand'" field="" header="" [style]="{'width':'7%','text-align':'center'}">
            <ng-template let-entry="rowData" pTemplate="body">
                <span class="transaction-detail fa fa-expand" (click)="showTransactionDetails(entry)"></span>
            </ng-template>
        </p-column> -->
<!--Already commented-->
        <!-- <p-column field="todayAmount" header="Today" [sortable]="true" >
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.todayAmount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.todayAmount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.todayAmount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.todayAmount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Interdesk'" [@flyInOut] [value]="interdeskFundingTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh"> -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Interdesk Funding Assumptions</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'desk'" style="width:40%">Desk
                    <p-sortIcon [field]="'desk'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'productType'" style="width:40%">Product Type
                    <p-sortIcon [field]="'productType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'amount'">Amount
                    <p-sortIcon [field]="'amount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:40%">{{row.desk}}</td>
                <td style="width:40%">{{row.productType}}</td>
                <td *ngIf="isPositive(row.amount)" class="positive-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.amount)" class="negative-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>



        <!-- <p-header [class]="'liquitics-h5 explain-header ' + currencyClass() ">Interdesk Funding Assumptions</p-header>
        <p-column field="desk" header="Desk" [sortable]="true" [style]="{'width':'40%'}"></p-column>
        <p-column field="productType" header="Product Type" [sortable]="true" [style]="{'width':'40%'}"></p-column>
        <p-column field="amount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.amount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.amount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.amount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.amount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
<!--Already commented-->
        <!-- <p-column field="basePercentage" header="%"></p-column>
        <p-column field="changedAmount" header="Amt Change">
            <ng-template let-row="rowData" pTemplate="body">
                {{row.changedAmount | number : '1.2-2'}}
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Client Level'" [@flyInOut] [value]="clientLevelFundingTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh"> -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Client Level Funding Assumptions</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'desk'" style="width:30%">Desk
                    <p-sortIcon [field]="'desk'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'clientGroup'" style="width:30%">Client Group
                    <p-sortIcon [field]="'clientGroup'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'productType'" style="width:20%">Product Type
                    <p-sortIcon [field]="'productType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'amount'">Amount
                    <p-sortIcon [field]="'amount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:30%">{{row.desk}}</td>
                <td style="width:30%">{{row.clientGroup}}</td>
                <td style="width:20%">{{row.productType}}</td>
                <td *ngIf="isPositive(row.amount)" class="positive-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.amount)" class="negative-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>


<!-- 
        <p-header [class]="'liquitics-h5 explain-header ' + currencyClass() ">Client Level Funding Assumptions</p-header>
        <p-column field="desk" header="Desk" [sortable]="true" [style]="{'text-align':'right','width':'30%'}"></p-column>
        <p-column field="clientGroup" header="Client Group" [sortable]="true" [style]="{'text-align':'right','width':'30%'}"></p-column>
        <p-column field="productType" header="Product Type" [sortable]="true" [style]="{'text-align':'right','width':'20%'}"></p-column>
        <p-column field="amount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.amount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.amount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.amount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.amount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
<!--Already commented-->
        <!-- <p-column field="basePercentage" header="%"></p-column>
        <p-column field="changedAmount" header="Amount">
            <ng-template let-row="rowData" pTemplate="body">
                {{row.changedAmount | number : '1.2-2'}}
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Predictions'" [@flyInOut] [value]="predictionTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh" > -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Predictions</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'clientGroup'" style="width:40%">Client Group
                    <p-sortIcon [field]="'clientGroup'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'productType'" style="width:40%">Product Type
                    <p-sortIcon [field]="'productType'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'amount'">Amount
                    <p-sortIcon [field]="'amount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:40%">{{row.clientGroup}}</td>
                <td style="width:40%">{{row.productType}}</td>
                <td *ngIf="isPositive(row.amount)" class="positive-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.amount)" class="negative-cell">
                    <span>{{row.amount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>

<!-- 
        <p-header [class]="'liquitics-h5 explain-header ' + currencyClass() ">Predictions</p-header>
        <p-column field="clientGroup" header="Client Group" [sortable]="true" [style]="{'width':'40%'}"></p-column>
        <p-column field="productType" header="Product Type" [sortable]="true" [style]="{'width':'40%'}"></p-column>
        <p-column field="amount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.amount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.amount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.amount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.amount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
<!--Already commented-->
        <!-- <p-column field="changedAmount" header="Changed">
            <ng-template let-row="rowData" pTemplate="body">
                <span *ngIf="isPositive(row.changedAmount)" [appTDCell]="[['positive-cell'],['negative-cell']]">{{row.changedAmount | number : '1.2-2'}}</span>
                <span *ngIf="isNegative(row.changedAmount)" [appTDCell]="[['negative-cell'],['positive-cell']]">{{row.changedAmount | number : '1.2-2'}}</span>
            </ng-template>
        </p-column> -->
    </p-table>
    <p-table *ngIf="selectedDataType === 'Corrections'" [@flyInOut] [value]="correctionTableDataToShow" scrollable="true" scrollHeight="40vh"
        sortMode="multiple" class="liquitics-compact-table" styleClass="p-datatable-striped">
<!--Already commented-->
        <!-- scrollHeight="40vh" > -->
        <ng-template pTemplate="caption">
            <span fxFlex="1 1 auto" fxFlexAlign="center" [class]="'liquitics-h5 explain-header ' + currencyClass()">Corrections</span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th [pSortableColumn]="'reason'" style="width:70%">Reason
                    <p-sortIcon [field]="'reason'"></p-sortIcon>
                </th>
                <th [pSortableColumn]="'flowAmount'">Amount
                    <p-sortIcon [field]="'flowAmount'"></p-sortIcon>
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr>
                <td style="width:70%">{{row.reason}}</td>
                <td *ngIf="isPositive(row.flowAmount)" class="positive-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
                <td *ngIf="isNegative(row.flowAmount)" class="negative-cell">
                    <span>{{row.flowAmount | number : '1.2-2'}}</span>
                </td>
            </tr>
        </ng-template>

<!-- 
        <p-header [class]="'liquitics-h5 explain-header ' + currencyClass() ">Corrections</p-header>
        <p-column field="reason" header="Reason" [style]="{'width':'70%'}"></p-column>
        <p-column field="flowAmount" header="Amount" [sortable]="true">
            <ng-template let-row="rowData" pTemplate="body">
                {{row.flowAmount | number : '1.2-2'}}
            </ng-template>
        </p-column> -->
    </p-table>
</div>